<template>
  <!-- 选择收藏夹 -->
  <el-dialog
    title="选择收藏夹"
    :append-to-body="true"
    :visible.sync="dialogCollectVisible"
    width="350px"
    class="collect-check"
  >
    <el-form class="g-form-grid" :model="form">
      <el-form-item a:label-width="formLabelWidth">
        <el-select placeholder="选择收藏夹" class="content" v-model="form.selectId">
          <el-option
            v-for="item in collectList"
            :key="item.centerId"
            :value="item.centerId"
            :label="item.centerName"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCollectVisible=false">取消</el-button>
      <el-button type="primary" @click="fromCollection">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    chooseRowIds: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tagList: [], // 已选藏品集合
      collectLength: 0,
      multipleSelection: [1], // 所选id集合
      dialogCollectVisible: false,
      form: {
        selectId: '' // 下拉框收藏夹id
      },
      collectList: [] // 收藏夹列表
    }
  },
  methods: {
    init() {
      this.collectLength = 0
      this.chooseRowIds &&
        (this.collectLength = this.chooseRowIds.split(',').length)

      if (!this.collectLength) {
        this.$message({
          message: '请选择藏品',
          type: 'warning'
        })
        return
      }

      this.dialogCollectVisible = true
      this.Collection()
    },
    // 选择收藏夹
    Collection() {
      this.dialogCollectVisible = true
      this.form.selectId = ''
      this.$http.get('/collection/getCollectCenterList').then(res => {
        if (res.success) {
          this.collectList = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 收藏夹确认
    fromCollection() {
      if (!this.form.selectId) {
        this.$message({
          message: '请选择收藏夹',
          type: 'warning'
        })
        return
      }
      this.$http
        .post('/collection/addCollectCenterInfo', {
          collectId: this.chooseRowIds, // 藏品ID
          centerId: this.form.selectId // 收藏夹ID
          // centerId: this.form.selectId.join(',') // 收藏夹ID
        })
        .then(res => {
          if (res.success) {
            this.$message.success(
              (this.pageType ? '' : this.collectLength + '件') + '藏品收藏成功'
            )
            this.$emit('refresh')
            this.dialogCollectVisible = false
          }
        })
    },
    // 取消收藏
    cancelCollect() {
      this.collectLength = 0
      this.chooseRowIds &&
        (this.collectLength = this.chooseRowIds.split(',').length)

      if (!this.collectLength) {
        this.$message({
          message: '请选择藏品',
          type: 'warning'
        })
      } else {
        this.$http
          .post('/collection/deleteCollectCenter', {
            collectId: this.chooseRowIds
          })
          .then(res => {
            if (res.success) {
              this.$message.success(
                (this.pageType ? '' : this.collectLength + '件') +
                  '藏品取消收藏成功'
              )
              this.$emit('refresh')
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


